import { inject, Service } from '@angular/core';
import { RxStompService } from '/app/shared/websocket/rx-stomp.service';


@Service()
export class MessageService {
  private _stompService: RxStompService = inject(RxStompService);

  constructor() {}

  public subscribeToTopic(topic: string) {
    return this._stompService.watch(topic)
  }
}
